module.exports = __webpack_public_path__ + "img/default_foto_lpd.8c0c7099.png";